goog.provide('el8.data.labOrderTests');

goog.require('el8.data.icd9Codes');
goog.require('el8.model.base');
goog.require('el8.service.urls');

el8.data.labOrderTests = (function() {

    // These are potential answers to "enum" questions
    var AOEQuestionChoice = function(spec) { this.parent.populate.call(this, spec); };
    AOEQuestionChoice.inheritsFrom(el8_Entity);
    AOEQuestionChoice.addStringProperty('code', true);
    AOEQuestionChoice.addStringProperty('value', true);


    var AOEQuestion = function(spec) {
        if (spec.choices) {
            spec.choices = spec.choices.map(function(spec) { return new AOEQuestionChoice(spec); });
        }
        this.parent.populate.call(this, spec);
    };
    AOEQuestion.inheritsFrom(el8_Entity);
    AOEQuestion.addStringProperty('code', true);
    AOEQuestion.addStringProperty('value', true);
    AOEQuestion.addStringProperty('questionType', true);
    AOEQuestion.addIntProperty('maxLength', true);
    AOEQuestion.addModelSetProperty('choices', AOEQuestionChoice, true, []);

    // Using this to ship up answer
    AOEQuestion.addStringProperty('responseValue', true);


    var AOEAnswer = function(spec) {
        spec = spec || {};
        this.populate(spec);
    };
    AOEAnswer.inheritsFrom(el8_Entity);
    AOEAnswer.addIntProperty('orderId');
    AOEAnswer.addIntProperty('testId');
    AOEAnswer.addIntProperty('questionId');
    AOEAnswer.addStringProperty('value', true);
    AOEAnswer.addModelProperty('question', function(spec) { return new AOEQuestion(spec); }, true);


    //
    // labOrderTest
    //
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.diagnoses) {
            spec.diagnosisIds = spec.diagnoses.map(function(a) { return a.id; });
            el8.data.icd9Codes.create(spec.diagnoses);
        }

        if (spec.questions) {
            spec.questions = spec.questions.map(function(spec) { return new AOEQuestion(spec); });
        }
        this.parent.populate.call(this, spec);
    };

    _class.addStringProperty('name');
    _class.addStringProperty('code');
    _class.addStringProperty('cpt');
    _class.addIntProperty('vendorId');
    _class.addIntProperty('compendiumId');
    _class.addProperty('diagnosisIds', false, []);
    _class.addModelSetProperty('questions', function(spec) { return new AOEQuestion(spec); }, true, []);
    _class.addStringProperty('procedureClass');

    _class.prototype.getNameWithCode = function() {
        return this.getName() + (this.getCode() ? ' ('+this.getCode()+')' : '');
    };

    _class.prototype.getDiagnoses = function() {
        return this.getDiagnosisIds().map(function(id) {
            return el8.data.icd9Codes.getById(id);
        });
    };

    _class.prototype.getLabcorpProcedureClass = function() {
        var procedureClass = this.getProcedureClass();

        if (procedureClass === 'CY') {
            return 'cytology';
        }
        else if (procedureClass === 'HI') {
            return 'histology';
        }
        else if (_.contains(['MI', 'MQ', 'MZ', 'VI', 'VX'], procedureClass)) {
            return 'microbiology';
        }
        else if (_.contains(['MA', 'CG'], procedureClass)) {
            return 'afp';
        }

        return 'unknown';
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) {
            return el8.service.urls.get('labOrderTests', [id]);
        }
    });

    that.AOEAnswer = function(spec) {
        return new AOEAnswer(spec);
    };

    that.AOEQuestion = function(spec) {
        return new AOEQuestion(spec);
    }

    return that;

})();
